/**
 * 관리자 헤더 알림 미읽음 개수 폴링.
 * 주기: `data-admin-notifications-poll-seconds`(초), 0이면 초기화하지 않음.
 */

const ROOT = "[data-admin-notifications]";
const ATTR_UNREAD_URL = "data-admin-notifications-unread-url";
const ATTR_POLL_SECONDS = "data-admin-notifications-poll-seconds";

function formatCount(count: number): string {
  const n = Math.max(0, Math.floor(count));
  return n > 99 ? "99+" : String(n);
}

function applyUnreadPill(root: HTMLElement, count: number): void {
  const pill = root.querySelector<HTMLElement>("[data-admin-notifications-unread]");
  if (!pill) return;
  const n = Math.max(0, Math.floor(count));
  pill.textContent = formatCount(n);
  pill.classList.toggle("is-unread", n > 0);
  pill.setAttribute("aria-label", `읽지 않은 알림 ${n}건`);
}

export function initAdminNotificationsUnreadPoll(): void {
  const root = document.querySelector<HTMLElement>(ROOT);
  if (!root) return;

  // AdminForm 의 mark-read/mark-all-read 직후 pill 즉시 갱신
  window.addEventListener("admin:notifications:unread-changed", (e: Event) => {
    const detail = (e as CustomEvent).detail as
      | { unread?: number; unread_counts?: Record<string, number> }
      | undefined;
    if (!detail) return;
    const counts = detail.unread_counts ?? {};
    const n =
      typeof detail.unread === "number"
        ? detail.unread
        : (typeof counts.all === "number" ? counts.all : 0);
    applyUnreadPill(root, n);
  });

  const url = root.getAttribute(ATTR_UNREAD_URL);
  if (!url) return;

  const pollRaw = root.getAttribute(ATTR_POLL_SECONDS);
  const pollSec = pollRaw != null && pollRaw !== "" ? parseInt(pollRaw, 10) : 30;
  if (!Number.isFinite(pollSec) || pollSec <= 0) return;

  const tick = (): void => {
    fetch(url, {
      method: "GET",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
    })
      .then((res) => res.json())
      .then((json: { data?: { unread?: number } }) => {
        const raw = json?.data?.unread;
        const n =
          typeof raw === "number" && Number.isFinite(raw)
            ? raw
            : parseInt(String(raw ?? "0"), 10) || 0;
        applyUnreadPill(root, n);
      })
      .catch(() => {
        /* 네트워크 오류 시 기존 표시 유지 */
      });
  };

  window.setInterval(tick, pollSec * 1000);
}
